/**
 * @generated SignedSource<<c0f3e2f8236d66f250ed199907375700>>
 * @relayHash 05ffd34fa5bbab01e2f30c02aed2c65a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 86fbcc3761e023c866715a47f9a81034800b47ed6e13666cad9721d0582b801d

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type srcReportsOverviewPageQuery$variables = {
  boardId: string;
  cloudId: string;
  isBoardContext: boolean;
  isMigrateTMPReportsOverviewEnabled: boolean;
  projectKey: string;
};
export type srcReportsOverviewPageQuery$data = {
  readonly jira_projectByIdOrKey?: {
    readonly projectType: JiraProjectType;
  };
  readonly " $fragmentSpreads": FragmentRefs<"reportCategoriesOld_reportsOverviewPage" | "reportCategories_reportsOverviewPage">;
};
export type srcReportsOverviewPageQuery = {
  response: srcReportsOverviewPageQuery$data;
  variables: srcReportsOverviewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isBoardContext"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMigrateTMPReportsOverviewEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectKey"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "concreteType": "JiraReportCategoryEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "JiraReportCategoryNode",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        {
          "concreteType": "JiraReportConnection",
          "kind": "LinkedField",
          "name": "reports",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraReportConnectionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraReport",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v7/*: any*/),
                    (v8/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "key"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "imageUrl"
                    },
                    {
                      "condition": "isMigrateTMPReportsOverviewEnabled",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "isNotApplicableReason"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "isNotApplicableDesc"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "description"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url"
                    },
                    (v9/*: any*/)
                  ]
                }
              ]
            }
          ]
        },
        (v9/*: any*/)
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "srcReportsOverviewPageQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "reportCategories_reportsOverviewPage"
      },
      {
        "kind": "FragmentSpread",
        "name": "reportCategoriesOld_reportsOverviewPage"
      },
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v5/*: any*/),
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jira_projectByIdOrKey",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v6/*: any*/),
                  "action": "THROW",
                  "path": "jira_projectByIdOrKey.projectType"
                }
              ]
            },
            "action": "THROW",
            "path": "jira_projectByIdOrKey"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "srcReportsOverviewPageQuery",
    "selections": [
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraReportCategoryConnection",
                "kind": "LinkedField",
                "name": "reportCategories",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "statusCode"
                          }
                        ]
                      }
                    ]
                  },
                  (v10/*: any*/)
                ]
              },
              (v9/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "boardId"
                  }
                ],
                "kind": "LinkedField",
                "name": "jiraBoard",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraReportCategoryConnection",
                        "kind": "LinkedField",
                        "name": "reportCategories",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/)
                        ]
                      }
                    ],
                    "type": "JiraBoard"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "86fbcc3761e023c866715a47f9a81034800b47ed6e13666cad9721d0582b801d",
    "metadata": {},
    "name": "srcReportsOverviewPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a328c09129eaecdb359972f8c5e6f8cd";

export default node;
